import pino from 'pino'
import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import type { PinoPublicRuntimeConfig } from './types'

export default defineNuxtPlugin({
    name: 'pino-logger',
    setup() {
        const config = useRuntimeConfig()
        const pinoConfig = config.public.pino as PinoPublicRuntimeConfig
        
        const logger = pino({
            level: pinoConfig?.level ?? 'info',
            browser: {
                asObject: true,
            },
        })
        
        return {
            provide: {
                logger,
            },
        }
    },
})
